import AmountInput from './amount-input';
import './amount-input.scss';

export default AmountInput;
